export default __webpack_public_path__ + "static/media/fc_icon_okay_active.26ac564c.svg";